<template>
    <div class="relative">
        <div aria-hidden="true" class="absolute inset-0 flex flex-col">
            <div class="flex-1"></div>
            <div class="flex-1 w-full"></div>
        </div>
        <div class="mx-auto ">
            <div class="relative">
                <div class="space-y-8">
                    <div class="flex space-x-6 text-sm rounded">
                        <div class="flex justify-center w-full bg-clay-50">
                            <div class="w-full pt-4 space-y-6 sm:px-0 px-4">
                               <div class="max-w-5xl pb-4 mx-auto md:flex md:items-center md:justify-between">
                                    <div class="items-center space-y-3 sm:-mx-4 sm:divide-x sm:divide-gray-200 md:flex md:space-y-0">
                                          <Menu as="div" class="relative block text-center border border-clay-500 md:text-left md:inline-block sm:border-0">
                                            <div>
                                                <MenuButton
                                                        class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">

                                                    <ArrowsUpDownIcon
                                                            class="w-5 h-5 mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                            aria-hidden="true"/>
                                                    <span v-if="request.sort.length > 0"
                                                          class="ml-1.5 font-semibold tabular-nums text-gray-700 hover:text-gray-900">{{
                                                            request.sort
                                                        }}</span>

                                                </MenuButton>

                                            </div>

                                            <transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in" leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
                                                <MenuItems class="z-10 mt-2 overflow-auto origin-top-left bg-white rounded-md shadow-2xl sm:absolute sm:left-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                    <div class="py-1">
                                                        <MenuItem v-for="option in sortOptions" :key="option.value">
                                                            <a :class="[option.value === request.sort ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm font-medium text-gray-900']" @click="request.sort=option.value">{{ option.text }}</a>
                                                        </MenuItem>
                                                    </div>
                                                </MenuItems>
                                            </transition>
                                        </Menu>
                                        


                                    </div>
                                    <div class="sm:block">
                                        <div class="flow-root">
                                            <PopoverGroup class="items-center divide-x divide-gray-200 sm:-mx-4 sm:flex">

                                                <Popover class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0">
                                                    <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">
                                                        <span>Gender</span>
                                                        <span v-if="request.genders.length > 0"
                                                              class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-600">{{
                                                                  request.genders.length
                                                              }}</span>
                                                        <ChevronDownIcon
                                                                class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true"/>
                                                    </PopoverButton>

                                                    <transition enter-active-class="transition duration-100 ease-out"
                                                                enter-from-class="transform scale-95 opacity-0"
                                                                enter-to-class="transform scale-100 opacity-100"
                                                                leave-active-class="transition duration-75 ease-in"
                                                                leave-from-class="transform scale-100 opacity-100"
                                                                leave-to-class="transform scale-95 opacity-0">
                                                        <PopoverPanel
                                                                class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                            <form class="space-y-4">
                                                                <div v-for="option in genderOptions" :key="option.text"
                                                                     class="flex items-center">
                                                                    <input :id="option.text"
                                                                           :value="option.value"
                                                                           v-model="request.genders"
                                                                           type="checkbox"
                                                                           class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                    <label :for="option.text"
                                                                           class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">{{
                                                                               option.text
                                                                           }}</label>
                                                                </div>
                                                            </form>
                                                        </PopoverPanel>
                                                    </transition>
                                                </Popover>

                                                <WalledOffFilter filter-title="Playing Age" content-for="ProOnly">
                                                    <template v-slot:content-title>
                                                        to use the <em>Playing Age</em> filter and to unlock other amazing theatre resources!
                                                    </template>
                                                    <template v-slot:pro>
                                                        <Popover class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0">
                                                            <PopoverButton
                                                                    class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">
                                                                <span>Playing Age</span>
                                                                <span v-if="request.ageRanges.length > 0"
                                                                      class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-600">{{
                                                                        request.ageRanges.length
                                                                    }}</span>
                                                                <ChevronDownIcon
                                                                        class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                        aria-hidden="true"/>
                                                            </PopoverButton>

                                                            <transition enter-active-class="transition duration-100 ease-out"
                                                                        enter-from-class="transform scale-95 opacity-0"
                                                                        enter-to-class="transform scale-100 opacity-100"
                                                                        leave-active-class="transition duration-75 ease-in"
                                                                        leave-from-class="transform scale-100 opacity-100"
                                                                        leave-to-class="transform scale-95 opacity-0">
                                                                <PopoverPanel
                                                                        class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                                    <form class="space-y-4">
                                                                        <div v-for="option in ageRangeOptions"
                                                                             :key="option.text"
                                                                             class="flex items-center">
                                                                            <input :id="option.text"
                                                                                   :value="option.value"
                                                                                   v-model="request.ageRanges"
                                                                                   type="checkbox"
                                                                                   class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                            <label :for="option.text"
                                                                                   class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">{{
                                                                                    option.text
                                                                                }}</label>
                                                                        </div>
                                                                    </form>
                                                                </PopoverPanel>
                                                            </transition>
                                                        </Popover>                                                        
                                                    </template>
                                                </WalledOffFilter>

                                                <WalledOffFilter filter-title="Length" content-for="ProOnly">
                                                    <template v-slot:content-title>
                                                        to use the <em>Length</em> filter and to unlock other amazing theatre resources!
                                                    </template>
                                                    <template v-slot:pro>
                                                        <Popover class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0">
                                                            <PopoverButton
                                                                    class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">
                                                                <span>Length</span>
                                                                <span v-if="request.durations.length > 0"
                                                                      class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-600">{{
                                                                        request.durations.length
                                                                    }}</span>
                                                                <ChevronDownIcon
                                                                        class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                        aria-hidden="true"/>
                                                            </PopoverButton>

                                                            <transition enter-active-class="transition duration-100 ease-out"
                                                                        enter-from-class="transform scale-95 opacity-0"
                                                                        enter-to-class="transform scale-100 opacity-100"
                                                                        leave-active-class="transition duration-75 ease-in"
                                                                        leave-from-class="transform scale-100 opacity-100"
                                                                        leave-to-class="transform scale-95 opacity-0">
                                                                <PopoverPanel
                                                                        class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                                    <form class="space-y-4">
                                                                        <div v-for="option in lengthOptions" :key="option"
                                                                             class="flex items-center">
                                                                            <input :id="option.text"
                                                                                   :value="option.value"
                                                                                   v-model="request.durations"
                                                                                   type="checkbox"
                                                                                   class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                            <label :for="option.text"
                                                                                   class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">{{
                                                                                    option.text
                                                                                }}</label>
                                                                        </div>
                                                                    </form>
                                                                </PopoverPanel>
                                                            </transition>
                                                        </Popover>
                                                    </template>
                                                </WalledOffFilter>

                                                <Popover class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0">
                                                    <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">
                                                        <span>Style</span>
                                                        <span v-if="request.styles.length > 0"
                                                              class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-600">{{
                                                                request.styles.length
                                                            }}</span>
                                                        <ChevronDownIcon
                                                                class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true"/>
                                                    </PopoverButton>

                                                    <transition enter-active-class="transition duration-100 ease-out"
                                                                enter-from-class="transform scale-95 opacity-0"
                                                                enter-to-class="transform scale-100 opacity-100"
                                                                leave-active-class="transition duration-75 ease-in"
                                                                leave-from-class="transform scale-100 opacity-100"
                                                                leave-to-class="transform scale-95 opacity-0">
                                                        <PopoverPanel
                                                                class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                            <form class="space-y-4">
                                                                <div v-for="option in styleOptions" :key="option"
                                                                     class="flex items-center">
                                                                    <input :id="option.text"
                                                                           :value="option.value"
                                                                           v-model="request.styles"
                                                                           type="checkbox"
                                                                           class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                    <label :for="option.text"
                                                                           class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">{{
                                                                            option.text
                                                                        }}</label>
                                                                </div>
                                                            </form>
                                                        </PopoverPanel>
                                                    </transition>
                                                </Popover>
                                                <Popover class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0">
                                                    <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">
                                                        <span>Time Period</span>
                                                        <span v-if="request.periods.length > 0"
                                                              class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-600">{{
                                                                request.periods.length
                                                            }}</span>
                                                        <ChevronDownIcon
                                                                class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true"/>
                                                    </PopoverButton>

                                                    <transition enter-active-class="transition duration-100 ease-out"
                                                                enter-from-class="transform scale-95 opacity-0"
                                                                enter-to-class="transform scale-100 opacity-100"
                                                                leave-active-class="transition duration-75 ease-in"
                                                                leave-from-class="transform scale-100 opacity-100"
                                                                leave-to-class="transform scale-95 opacity-0">
                                                        <PopoverPanel
                                                                class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                            <form class="space-y-4">
                                                                <div v-for="option in periodOptions" :key="option.text"
                                                                     class="flex items-center">
                                                                    <input :id="option.text"
                                                                           :value="option.value"
                                                                           v-model="request.periods"
                                                                           type="checkbox"
                                                                           class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                    <label :for="option.text"
                                                                           class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">{{
                                                                            option.text
                                                                        }}</label>
                                                                </div>
                                                            </form>
                                                        </PopoverPanel>
                                                    </transition>
                                                </Popover>
                                                <Popover class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0">
                                                    <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0 ">
                                                        <span>Additional</span>
                                                        <span v-if="additionalOptions.length > 0"
                                                              class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-600">{{
                                                                additionalOptions.length
                                                            }}</span>
                                                        <ChevronDownIcon
                                                                class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true"/>
                                                    </PopoverButton>

                                                    <transition enter-active-class="transition duration-100 ease-out"
                                                                enter-from-class="transform scale-95 opacity-0"
                                                                enter-to-class="transform scale-100 opacity-100"
                                                                leave-active-class="transition duration-75 ease-in"
                                                                leave-from-class="transform scale-100 opacity-100"
                                                                leave-to-class="transform scale-95 opacity-0">
                                                        <PopoverPanel
                                                                class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                            <form class="space-y-4">
                                                                <div class="flex items-center">
                                                                    <input v-model="request.displaysFullText"
                                                                           type="checkbox"
                                                                           class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                    <label for="displaysFullText"
                                                                           class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">Text</label>
                                                                </div>
                                                                <div class="flex items-center">
                                                                    <input v-model="request.withVideo"
                                                                           type="checkbox"
                                                                           class="w-4 h-4 border-clay-500 rounded text-electric-700 focus:ring-clay-500"/>
                                                                    <label for="withVideo"
                                                                           class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap hover:font-medium">Video</label>
                                                                </div>
                                                            </form>
                                                        </PopoverPanel>
                                                    </transition>
                                                </Popover>
                                            </PopoverGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div ref="resultsSection" class="min-h-screen py-8">
        <div class="max-w-6xl px-4 mx-auto sm:px-6 lg:px-8">
          <div v-if="monologuesRetrieved === true" >
            <div v-if="searchMonologuesByFilterResponse.results?.length > 0">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                <MonologueCard v-for="monologue in searchMonologuesByFilterResponse.results" 
                               :key="monologue.id"
                               :monologue="monologue"/>
            </div>
            <paginate v-model="searchMonologuesByFilterResponse.currentPage"
                      :active-class="'border border-electric-700 text-electric-700 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-bold border-x-0 border-b-0'"
                        :click-handler="clickHandler"
                        :container-class="'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 mt-8'"
                        :margin-pages="2"
                        :next-class="'-mt-px w-0 flex-1 flex justify-end'"
                        :next-link-class="'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-clay-900 hover:border-electric-700'"
                        :next-text="nextHtml"
                        :page-class="'hover:text-clay-900 hover:border-electric-700 hover:border-t-2 hover:border pt-4 px-4 inline-flex items-center text-sm font-medium dark:text-gray-400'"
                        :page-count="getPageCount()"
                        :page-range="3"
                        :prev-class="'-mt-px w-0 flex-1 flex'"
                        :prev-link-class="'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-clay-900 hover:border-electric-700'"
                      :prev-text="prevHtml"
            >
            </paginate>
            </div>
            <empty-results-notification v-else/>
          </div>
          <SkeletonCard card-style="long" :num-of-cards=4 v-else/>

        </div>
    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineComponent, defineProps, onMounted, ref, Ref, watch} from "vue";
import {client} from '@/shared';
import {
    SearchMonologuesByFiltersRequest,
    SearchMonologuesByFiltersResponse,
} from "@/dtos";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
// @ts-ignore
import {CheckIcon, ArrowsUpDownIcon} from '@heroicons/vue/20/solid';
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import EmptyResultsNotification from "@/main/components/EmptyResultsNotification.vue";
import {
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems
} from '@headlessui/vue'

import {ChevronDownIcon} from '@heroicons/vue/20/solid'
import MonologueCard from "./MonologueCard.vue";
import WalledOffFilter from "../../Shared/WalledOffFilter.vue";

const open = ref(false)

const props = defineProps({
    genderOptions: Array,
    ageRangeOptions: Array,
    lengthOptions: Array,
    styleOptions: Array,
    periodOptions: Array
});

const sortOptions = [
    {text: 'Best Match', value: 'Best Match'},
    {text: 'Popular', value: 'Popular'},
    {text: 'Last Updated', value: 'Last Updated'}
];

const additionalOptions = computed(() => {
    let options = [];
    if(request.value.displaysFullText === true)
        options.push("text");
    
    if(request.value.withVideo === true)
        options.push("video");
    
    return options;
});

const shouldScroll = ref(false);
const monologuesRetrieved = ref(false);
const searchMonologuesByFilterResponse = ref(new SearchMonologuesByFiltersResponse());
const request = ref(new SearchMonologuesByFiltersRequest({
    genders: [],
    ageRanges: [],
    durations: [],
    styles: [],
    periods: [],
    displaysFullText: true,
    withVideo: false,
    sort: 'Best Match'
}));

const resultsSection = ref(null);

const filter = async () => {
    monologuesRetrieved.value = false;
   
    await client.get<SearchMonologuesByFiltersResponse>(request.value)
        .then(res => {
            monologuesRetrieved.value = true;
            searchMonologuesByFilterResponse.value = res;
            if(shouldScroll.value){
                resultsSection.value.scrollIntoView({
                    behavior: "smooth"
                });
            }
            shouldScroll.value = true;
        });
}

const clickHandler = async (pageNum: any) => {
    request.value.currentPage = pageNum;
    await filter();
}

const getPageCount = () => {
    return Math.ceil(searchMonologuesByFilterResponse.value.totalResults / 12);
}

watch([
        () => request.value.genders,
        () => request.value.ageRanges,
        () => request.value.durations,
        () => request.value.styles,
        () => request.value.periods,
        () => request.value.displaysFullText,
        () => request.value.withVideo,
        () => request.value.sort,
    ], async ([]) => {
        request.value.currentPage = 1;
        await filter();
    },
    { immediate: true }
);

const nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

const prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;


</script>
<style>
a {
    cursor: pointer;
}

</style>